import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import SEO from "../components/SEO";
import { CheckCircle2, MessageCircle, Phone } from "lucide-react";

export default function Register() {
  const [form, setForm] = useState({ name: "", mobile: "", email: "", city: "", patient_type: "child", message: "", consent: false });
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.consent) return toast.error("Please accept consent.");
    try {
      await api.post("/counsellor-request", form);
      setDone(true);
      toast.success("Thank you. A counsellor will call you soon.");
    } catch (err) { toast.error("Could not submit. Try again."); }
  };

  return (
    <>
      <SEO title="Register / Get Help — Speak to a HearClear CI Counsellor" />
      <section className="bg-gradient-to-br from-[#F0F9FF] via-white to-[#ECFDF5] py-14">
        <div className="hc-container max-w-4xl">
          <h1 className="font-serif text-[2.25rem] md:text-[3rem] font-semibold leading-[1.08] text-slate-900">Register / Get Help</h1>
          <p className="mt-5 text-slate-700 text-[1.05rem]">Tell us about yourself or your child. A HearClear cochlear implant counsellor will reach out at your preferred time.</p>
        </div>
      </section>

      <section className="hc-container py-12 grid lg:grid-cols-3 gap-8 max-w-6xl">
        <div className="lg:col-span-2">
          {done ? (
            <div className="bg-emerald-50 border border-emerald-200 rounded-2xl p-8 text-center">
              <CheckCircle2 size={36} className="text-emerald-600 mx-auto" />
              <div className="mt-3 font-serif text-xl font-semibold text-slate-900">Thank you</div>
              <p className="mt-2 text-slate-700">A HearClear counsellor will reach out soon. You can also call us directly.</p>
            </div>
          ) : (
            <form data-testid="register-form" onSubmit={submit} className="bg-white border border-slate-200 rounded-2xl p-6 md:p-8 space-y-4">
              <div className="grid md:grid-cols-2 gap-4">
                <div><label className="label-hc">Full name *</label><input data-testid="reg-name" required className="input-hc" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
                <div><label className="label-hc">Mobile *</label><input data-testid="reg-mobile" required className="input-hc" value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} /></div>
                <div><label className="label-hc">Email</label><input data-testid="reg-email" type="email" className="input-hc" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
                <div><label className="label-hc">City</label><input data-testid="reg-city" className="input-hc" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} /></div>
                <div className="md:col-span-2"><label className="label-hc">Patient type</label>
                  <select data-testid="reg-ptype" className="input-hc" value={form.patient_type} onChange={(e) => setForm({ ...form, patient_type: e.target.value })}>
                    <option value="child">Parent of child</option><option value="adult">Adult patient</option><option value="caregiver">Caregiver / relative</option><option value="doctor">Doctor / professional</option><option value="csr">CSR enquiry</option><option value="other">Other</option>
                  </select>
                </div>
                <div className="md:col-span-2"><label className="label-hc">How can we help?</label><textarea data-testid="reg-message" className="input-hc" rows={4} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} /></div>
              </div>
              <label className="flex items-start gap-3 cursor-pointer"><input data-testid="reg-consent" required type="checkbox" className="mt-1 w-5 h-5 accent-[#0369A1]" checked={form.consent} onChange={(e) => setForm({ ...form, consent: e.target.checked })} /><span className="text-slate-700 text-[14.5px]">I consent to HearClear contacting me on phone / email / WhatsApp for cochlear implant guidance.</span></label>
              <button data-testid="reg-submit" className="btn-primary">Request counsellor callback</button>
            </form>
          )}
        </div>
        <aside className="space-y-5">
          <a href="tel:+919000000000" data-testid="reg-call" className="card-hc block">
            <span className="w-12 h-12 rounded-xl bg-[#F0F9FF] flex items-center justify-center text-[#0369A1] mb-3"><Phone size={22} /></span>
            <div className="font-serif text-lg font-semibold text-slate-900">Call counsellor</div>
            <div className="mt-1 text-[#0369A1] font-semibold">+91 90000 00000</div>
          </a>
          <a href="https://wa.me/919000000000" target="_blank" rel="noopener noreferrer" data-testid="reg-whatsapp" className="card-hc block">
            <span className="w-12 h-12 rounded-xl bg-[#ECFDF5] flex items-center justify-center text-[#0F766E] mb-3"><MessageCircle size={22} /></span>
            <div className="font-serif text-lg font-semibold text-slate-900">WhatsApp HearClear</div>
            <div className="mt-1 text-slate-600 text-[14.5px]">Chat with our counsellor</div>
          </a>
        </aside>
      </section>
    </>
  );
}
